import { Injectable } from '@angular/core'
// import * as FileSaver from 'file-saver'
import * as XLSX from 'xlsx'

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
const EXCEL_EXTENSION = '.xlsx'

@Injectable()
export class ExcelService {

    constructor() { }

    public exportAsExcelFile(json: any[], excelFileName: string, year1: string, year2:string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json)
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] }

        var currentDate = new Date()

        var currYear = currentDate.getFullYear()
        var lastYear = currYear - 1
        delete worksheet['F1'].w
        delete worksheet['G1'].w

        worksheet['F1'].v = "Training Status " + year1 //+ lastYear.toString()
        worksheet['G1'].v = "Training Status " + year2 //+ currYear.toString()

        XLSX.writeFile(workbook, excelFileName + EXCEL_EXTENSION, { bookType: 'xlsx', type: 'buffer' })
       // const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' })
       // this.saveAsExcelFile(excelBuffer, excelFileName)
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        })
       // FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION)
    }

    public exportAsExelFormatted(json: any[], excelFileName: string, year1: string,year2: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json)
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] }
        

         delete worksheet['A1'].w
        delete worksheet['B1'].w       
         delete worksheet['C1'].w
        delete worksheet['D1'].w
        delete worksheet['E1'].w
        delete worksheet['F1'].w
        delete worksheet['G1'].w
        

        worksheet['A1'].v = "Login ID"
        worksheet['B1'].v = "Name"
        worksheet['C1'].v = "User Type"
        worksheet['D1'].v = "Status"
        worksheet['E1'].v = "Training " + year1
        worksheet['F1'].v = "Training " + year2
        worksheet['G1'].v = "Org Name" 
        
        
        XLSX.writeFile(workbook, excelFileName + EXCEL_EXTENSION, { bookType: 'xlsx', type: 'buffer' })
        
    }



}

